import React from "react";

const CustomSelect = ({
  register,
  name,
  errors,
  placeholder,
  option,
  label,
}) => {
  return (
    <div>
      {label && (
        <label style={{ display: "block", marginBottom: "5px" }}>{label}</label>
      )}
      <select
        style={{
          backgroundColor: "#f0f1f3",
          width: "100%",
          height: "50px",
          color: "gray",
          outline: "none",
          border: "none",
          borderRadius: "3px",
        }}
        placeholder={placeholder}
        name={name}
        {...register(name, {
          required: true,
          validate: (value) =>
            value.trim() !== "" || "only space are not allowed",
        })}
      >
        {option?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors?.[name] && <p style={{ color: "red" }}>This field is required</p>}
    </div>
  );
};

export default CustomSelect;
